import { styled } from '@mui/material/styles';
import { Accordion } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const Container = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
});

export const AccordionStyle = styled(Accordion)({
  border: `1px solid ${abyssColors.primary[200]}`,
  backgroundColor: `${abyssColors.primary[50]} !important`,
  borderRadius: '4px !important',
  padding: '16px 20px',
  marginBottom: '70px !important',
  marginTop: '32px !important',
  '&.MuiAccordion-root::before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px !important',
  },
});

export const scrollDesign = {
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    borderRadius: '10px',
    background: '#F6F8FB',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    background: '#c7c7c7',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#b3b3b3',
  },
  overflowX: 'scroll',
};

export const subHeadingUnitStyles = {
  color: abyssColors.primary[500],
  fontWeight: 500,
  whiteSpace: 'nowrap',
};

export const InsightsContainer = styled('main')<{
  isLeftDrawerOpen?: boolean;
  isRightDrawerOpen?: boolean;
  navbarHeight: number;
}>(({ theme, isLeftDrawerOpen, isRightDrawerOpen, navbarHeight }) => ({
  overflowY: 'auto',
  height: `calc(100vh  / var(--zoom) - ${navbarHeight}px)`,
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  flexGrow: 1,
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  paddingTop: 0,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(isLeftDrawerOpen && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(isRightDrawerOpen && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const tabStyles = {
  '& button': {
    textTransform: 'none',
    '@media (max-width: 1728px)': {
      padding: '12px 16px',
      minHeight: 'fit-content',
    },
  },
};

export const poiNavigation = {
  '& .poiNavigation': {
    maxWidth: '6rem',     
    
  },
};
